import React, { useEffect, useState } from 'react';
import { PhoneIcon } from 'lucide-react';
export function Header() {
  const [isAtTop, setIsAtTop] = useState(true);
  useEffect(() => {
    function handleScroll() {
      setIsAtTop(window.scrollY <= 8);
    }
    handleScroll();
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <header className="sticky top-0 z-50 w-full bg-brand-charcoal" data-id="element-40" data-mp="m1meztd5yeqj">
      <div className="relative mx-auto flex h-16 max-w-7xl items-center justify-between gap-3 px-4 sm:h-20 sm:gap-6 sm:px-6 lg:px-8" data-id="element-41" data-mp="hzrf8tavs9ev">
        {/* Teal logo panel: aligned with the page content, hanging below the bar at the top
            of the page and collapsing into the bar once the user scrolls. */}
        <a href="#top" aria-label="Granite &amp; Marble Works, Inc. — back to top" className={`absolute left-4 top-0 flex items-center justify-center bg-brand-teal px-4 shadow-lg transition-[height] duration-300 ease-out sm:left-6 sm:px-5 md:px-6 lg:left-8 ${isAtTop ? 'h-24 w-28 sm:h-32 sm:w-36 md:h-40 md:w-44' : 'h-16 w-28 sm:h-20 sm:w-36 md:w-44'}`} data-id="element-42" data-mp="39juu81bcgbj">
          <img src="https://cdn.magicpatterns.com/uploads/bUK4G3YzLjUPKikZeYKRwp/GraniteMarbleWorks.png" alt="Granite &amp; Marble Works, Inc." className="max-h-14 w-full object-contain" data-id="element-43" data-mp="gm9ry01hizv6" />
        </a>

        {/* Spacer reserving the logo panel's footprint in the bar layout */}
        <div className="w-28 shrink-0 sm:w-36 md:w-44" aria-hidden="true" data-id="element-44" data-mp="3u0ebo6rlvnlh" />

        <div className="flex items-center gap-3 sm:gap-6" data-id="element-45" data-mp="3u2h9hcz02l0r">
          <a href="tel:+15185842800" className="hidden items-center gap-2 text-sm font-medium text-white/90 transition-colors hover:text-white sm:flex" data-id="element-46" data-mp="1xn3n8tvqxrt">
            <PhoneIcon className="h-4 w-4 text-brand-teal" aria-hidden="true" data-id="element-47" data-mp="1dazbrvwoa2js" />
            (518) 584-2800
          </a>
          <a href="#hero-form" className="inline-flex items-center justify-center whitespace-nowrap rounded-md bg-brand-teal px-4 py-2.5 text-xs font-semibold uppercase tracking-wide text-white transition-colors hover:bg-brand-tealDark sm:text-sm" data-id="element-48" data-mp="3ab2596nfcg2h">
            Schedule Appointment
          </a>
        </div>
      </div>
    </header>;
}